import { EventEmitter } from "events";

import Dispatcher from "./dispatcher";
import Constants from "./constants";
import getSidebarNavItems from "../data/sidebar-nav-items";

let _store = {
  menuVisible: false,
  navItems: getSidebarNavItems(),
  selectedCategories: [],
  notificationCount: parseInt(localStorage.getItem('notificationCount'), 10) || 0
};

class Store extends EventEmitter {
  constructor() {
    super();

    this.registerToActions = this.registerToActions.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);

    Dispatcher.register(this.registerToActions.bind(this));
  }
  registerToActions({ actionType, payload }) {
    switch (actionType) {
      case Constants.TOGGLE_SIDEBAR:
        this.toggleSidebar();
        break;
      case Constants.SELECTED_CATEGORY:
        if (_store.selectedCategories.includes(payload)) {
          _store.selectedCategories = _store.selectedCategories.filter((item) => item !== payload)
        } else {
          _store.selectedCategories.push(payload);
        }
        this.emit(Constants.SELECTED_CATEGORY);
        break;
      case Constants.INCREMENT_NOTIFICATION:
        _store.notificationCount += 1;
        localStorage.setItem('notificationCount', _store.notificationCount);
        this.emit(Constants.INCREMENT_NOTIFICATION);
        break;
      case Constants.RESET_NOTIFICATION:
        _store.notificationCount = 0;
        localStorage.setItem('notificationCount', _store.notificationCount);
        this.emit(Constants.RESET_NOTIFICATION);
        break;
      default:
    }
  }

  toggleSidebar() {
    _store.menuVisible = !_store.menuVisible;
    this.emit(Constants.CHANGE);
  }

  getMenuState() {
    return _store.menuVisible;
  }

  getSidebarItems() {
    return _store.navItems;
  }

  getSelectedCategories() {
    return _store.selectedCategories;
  }

  getNotificationCount() {
    return _store.notificationCount;
  }

  addChangeListener(callback) {
    this.on(Constants.CHANGE, callback);
    this.on(Constants.SELECTED_CATEGORY, callback);
    this.on(Constants.INCREMENT_NOTIFICATION, callback);
    this.on(Constants.RESET_NOTIFICATION, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
    this.removeListener(Constants.SELECTED_CATEGORY, callback);
    this.removeListener(Constants.INCREMENT_NOTIFICATION, callback);
    this.removeListener(Constants.RESET_NOTIFICATION, callback);
  }
}

export default new Store();
